import { cn } from '@/lib/utils';

interface CharacterCounterProps {
  current: number;
  max: number;
  className?: string;
}

export function CharacterCounter({ current, max, className }: CharacterCounterProps) {
  const percentage = max > 0 ? current / max : 0;
  const isOverLimit = current > max;
  const isNearLimit = !isOverLimit && percentage >= 0.9;

  return (
    <span
      className={cn(
        'text-3xs tabular-nums text-muted-foreground',
        isNearLimit && 'text-warning',
        isOverLimit && 'text-destructive',
        className,
      )}
      aria-live="polite"
      aria-label={`${current} of ${max} characters used`}
    >
      {current}/{max}
    </span>
  );
}
